<template>
  <v-app id="userDetails" class="user-details">
    <div class="navBar">
      <img :src="darkMode?brandingService.getLoginDarkLogoUrl():brandingService.getLoginLogoUrl()"
           alt="brandingService.getLoginLogoAlt()"
           class="logo" />
      <div class="header-container">
        <div class="pageTitle">User Profile</div>
        <div class="headerTab overviewTab">Overview</div>
      </div>
      <a :href="brandingService.getSupportUrl('userDetails')" class="helpButton" target="_blank"><i
          class="fal fa-question-circle"></i></a>
    </div>

    <nav class="sidebar-container" app clipped permanent>
      <user-details-sidebar :userData="sidebarData"></user-details-sidebar>
    </nav>

    <div class="user-details-main-container">
      <div class="user-details-grid-container">
        <user-details-grid :user-email="userEmail" :date-range="dateRange" :licenses="licenseData"></user-details-grid>
      </div>
      <a class="user-details-footer" href="http://www.vyopta.com" target="_blank">
        © {{currentYear}} HP Inc.
         <a href="https://www.hp.com/us-en/privacy/privacy-central.html" target="_blank">Privacy Statement</a>,
        <a href="https://support.hp.com/us-en/document/ish_12775809-12775790-16" target="_blank">EULA</a>,
        and <a href="https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf" target="_blank">DPA</a>
      </a>
    </div>
  </v-app>
</template>

<script>
import UserDetailsService from './user-details.service';
import UserDetailsSidebar from './userDetailsSidebar.vue';
import UserDetailsGrid from './userDetailsGrid.vue';
import moment from 'moment-timezone';
import BrandingService from "../../../services/branding.service";
export default {
  name: 'user-details',
  components: {
    UserDetailsSidebar,
    UserDetailsGrid
  },
  props: {
    route: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    const isDarkMode = document.body.classList.contains('dark');
    return {
      userId: '',
      userEmail: '',
      dateRange: {
        startDate: undefined,
        endDate: undefined
      },
      licenseData: {},
      sidebarData: {},
      currentYear: moment().year(),
      brandingService: BrandingService,
      darkMode: isDarkMode,
    }
  },
  watch: {
    route: {
      deep: true,
      handler(newRoute, oldRoute) {
        let self = this;

        // if navigating away from userDetails, do nothing
        if (newRoute.view !== 'historical2-user-details-view') {
          return;
        }

        if (!newRoute.userId) {
          // route.userId is required
          throw new Error('URL param \'userId\' is missing or undefined');
        }

        self.userId = newRoute.userId;
        // URL dates are in millis, so we need to cast to Number
        self.dateRange.startDate = moment(+newRoute.startDate);
        self.dateRange.endDate = moment(+newRoute.endDate);

        if (newRoute.userId !== oldRoute.userId) {
          self.fetchData();
        }
      }
    }
  },
  mounted() {
    let self = this;

    if (!self.route || !self.route.userId) {
      // route.userId is required to load data
      throw new Error('URL param \'userId\' is missing or undefined');
    }

    self.userId = self.route.userId;
    // URL dates are in millis, so we need to cast to Number
    self.dateRange.startDate = moment(+self.route.startDate);
    self.dateRange.endDate = moment(+self.route.endDate);
    self.fetchData();
  },
  methods: {
    fetchData: function() {
      let self = this;

      function getLocationString(city, state, country) {
        let result = '',
            hasCity = city && city.toLowerCase() !== 'unknown',
            hasState = state && state.toLowerCase() !== 'unknown',
            hasCountry = country && country.toLowerCase() !== 'unknown';

        if (!hasCity && !hasState && !hasCountry) {
          return 'Unknown';
        }

        if (hasCity) {
          result += city;
          if (hasState) { result += ', '; }
        }
        if (hasState) {
          result += state;
          if (hasCountry) { result += ' '; }
        }
        if (hasCountry) {
          result += country;
        }

        return result;
      }

      UserDetailsService.getUserData(self.userId)
        .then(data => {
          let userData = data[0];

          self.sidebarData = {
            name: `${userData['dimuser.firstname']} ${userData['dimuser.lastname']}`,
            email: userData['dimuser.email'],
            title: userData['dimuser.title'],
            department: userData['dimuser.department'],
            location: getLocationString(userData['dimuser.city'], userData['dimuser.state'], userData['dimuser.country']),
            msTeamsLicense: userData['userprofilexml.msteamslicense'],
            webexLicense: userData['userprofilexml.ciscowebexlicense'],
            gmeetLicense: userData['userprofilexml.gmeetlicense'],
            zoomLicense: userData['userprofilexml.zoomlicense']
          }

          self.licenseData = {
            msteams: userData['userprofilexml.msteamslicense'] && userData['userprofilexml.msteamslicense'].toLowerCase() === 'licensed',
            webex: userData['userprofilexml.ciscowebexlicense'] && userData['userprofilexml.ciscowebexlicense'].toLowerCase() === 'licensed',
            gmeet: userData['userprofilexml.gmeetlicense'] && userData['userprofilexml.gmeetlicense'].toLowerCase() === 'licensed',
            zoom: userData['userprofilexml.zoomlicense'] && userData['userprofilexml.zoomlicense'].toLowerCase() === 'licensed'
          };

          self.userEmail = userData['dimuser.email'];
        });
    }
  }
}
</script>

<style scoped lang="scss">

$navBarHeight: 50px;
.user-details {
  font-family: var(--font-family);
  .navBar {
    height: $navBarHeight;
    background-color: var(--panel-background);
    position: fixed;
    z-index: 1000;
    width: 100%;
    .logo {
      height: 42px;
      width: auto;
      margin-top: 23.5px;
      margin-left: 19.5px;
    }
    .header-container {
      position: absolute;
      color: var(--text-color);
      left: 318px;
      top: 0;
      font-size: 22px;
      font-weight: 600;
      margin: 0;

      div {
        display: inline-block;
        line-height: $navBarHeight;

        &.headerTab {
          margin-left: 20px;
          position: relative;
          top: -1px;
          padding: 0 25px;
          background-color: var(--disabled-background);
          font-size: 18px;
        }
      }
    }
    .helpButton {
      position: absolute;
      right: 0;
      top: 0;
      width: 50px;
      height: 50px;
      text-align: center;
      &:hover {
       background-color: var(--disabled-background);
      }
      .fal {
        margin-top: 14px; // (50 - 22) / 2
        font-size: 22px;
        color: var(--text-color);
      }
    }
  }
  .sidebar-container {
    background-color: var(--panel-background);
    color: var(--text-color);
    display: flex;
    flex-direction: column;
    text-align: center;
    width: var(--side-bar-width);
    height: 100vh;
    position: fixed;
    margin-top: 50px;
  }

  .user-details-main-container {
    background-color: var(--background-color);
    padding: 68px 20px 20px calc(var(--side-bar-width) + 20px);
    min-height: 100vh;

    .user-details-grid-container {
      border-radius: var(--border-radius);
    }

    .user-details-footer {
      display: block;
      color: #253035 !important;
      font-size: 9px;
      text-align: center;
      margin-top: 14px;
    }
  }

  @media (max-width: 991px) {
    .sidebar-container {
      height: auto;
      width: auto;
      position: static;
    }
    .user-details-main-container {
      padding: 18px 18px 10px 16px;
    }
    .navBar {
      border-bottom: 1px solid white;
      .helpButton {
        height: 48px;
      }
    }
  }
  @media (max-width: 767px) {
    .navBar .header-container {
      left: 130px;

      .overviewTab {
        display: none;
      }
    }
    .sidebar-container .user-details-sidebar {
      flex-direction: column;
    }
  }
}
</style>
